import { FC } from 'react';

const NotFoundPage: FC = () => {
  return (
    <div className="not-found-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container mx-auto px-4 py-16">
          <div className="text-center">
            <div className="mb-8">
              <img src="/images/dldv_white.svg" alt="DLDV" className="w-32 h-32 mx-auto mb-6 opacity-100" />
            </div>
            <h1 className="text-6xl md:text-8xl font-extrabold mb-4">404</h1>
            <h2 className="text-2xl md:text-3xl font-bold mb-4">Page Not Found</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default NotFoundPage;
